var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Sentry, SentryTeam } from 'lib-shared-sentry';
import { createAuthorizationHeaderValue } from './axiosBaseQuery';
import { ApiErrorStatusCode } from './axiosBaseQuery.types';
/**
 * Adds a response interceptor to handle api errors.
 *
 * @param instance The axios instance.
 */
export function addErrorInterceptors(instance, errorHandlers) {
    instance.interceptors.response.use((response) => response, (error) => {
        if (error.response) {
            const { status } = error.response;
            for (const errorHandler of errorHandlers) {
                if (status === errorHandler.errorCode) {
                    // If a 401 response is received, we want to capture the error in Sentry
                    if (status === ApiErrorStatusCode.Unauthorized) {
                        Sentry.captureMessage('401 unauthorized interceptor', {
                            level: 'debug',
                            tags: {
                                team: SentryTeam.Platform,
                            },
                        });
                        console.error('401 unauthorized interceptor');
                    }
                    errorHandler.handler(instance, error);
                }
            }
        }
        return Promise.reject(error);
    });
}
/**
 * Adds a request interceptor to wait for the refresh token.
 *
 * @param instance The axios instance.
 */
export function addRefreshTokenInterceptor(instance) {
    instance.interceptors.request.use((config) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        if ((_a = config.headers) === null || _a === void 0 ? void 0 : _a['Authorization']) {
            config.headers['Authorization'] = yield createAuthorizationHeaderValue();
        }
        return config;
    }));
}
//# sourceMappingURL=interceptors.js.map